module.exports = __webpack_public_path__ + "assets/img/9.334715b0.png";